import { gql } from "@apollo/client";

export const GENERATE_LAYOUT_MUTATION = gql`
  mutation GenerateLayout($input: GenerateLayoutInput!) {
    generateLayout(input: $input) {
      statusCode
      message
      cssKey
      jsxKey
    }
  }
`;
